/* eslint-disable no-unused-vars */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
/* eslint-disable react/no-unused-state */
import React from 'react';
import { Form } from 'antd';
import { Grid, TextField, Snackbar } from '@material-ui/core';
import MySnackbarContentWrapper from '../../../../components/SnackBar';
import { getFriendlyErrorMessage } from '../../../../utils/errorHelper';
import { SelectBrands } from './SelectBrands';

class brandForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    snackOpen: false,
    snackType: 'info',
    snackMessage: 'Action executing...',
    parentId: undefined,
  };

  componentDidMount() {
    this.setState({ parentId: this.props.parent?.id || undefined });
  }

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open, type, message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  handleParentChange = (parentId) => {
    this.setState({ parentId });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ snackOpen: true });
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.query_f({
          variables: {
            id: this.props.id,
            name: values.name,
            website: values.website,
            address: values.address,
            state: values.state,
            country: values.country,
            phoneNumber: values.phoneNumber,
            previousName: values.previousName,
            parent: this.state.parentId,
          },
        }).then(result => {
          this.setStateValues(true, 'success', 'Action executed with success!');
          if (this.props.onCancel) {
            this.props.onCancel();
          }
        }, error => {
          this.setStateValues(true, 'error', getFriendlyErrorMessage(error));
        });
      } else {
        this.setStateValues(true, 'error', 'Form validation failed!');
      }
    });
  }

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <form id="myForm2" onSubmit={this.handleSubmit}>
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackOpen} autoHideDuration={6000} onClose={this.handleClose}>
          <MySnackbarContentWrapper onClose={this.handleClose} variant={this.state.snackType} message={this.state.snackMessage} />
        </Snackbar>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            {getFieldDecorator('name', { initialValue: (this.props.name || ''), rules: [{ required: true }] })(
              <TextField id="name" label="name" color="primary" fullWidth style={{ marginTop: 13 }} InputLabelProps={{ shrink: true }} placeholder="" />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('website', { initialValue: (this.props.website || ''), rules: [{ required: false }] })(
              <TextField id="website" label="website" color="primary" fullWidth style={{ marginTop: 13 }} InputLabelProps={{ shrink: true }} placeholder="" />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('address', { initialValue: (this.props.address || ''), rules: [{ required: false }] })(
              <TextField id="address" label="address" color="primary" fullWidth style={{ marginTop: 13 }} InputLabelProps={{ shrink: true }} placeholder="" />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('state', { initialValue: (this.props.state || ''), rules: [{ required: false }] })(
              <TextField id="state" label="state" color="primary" fullWidth style={{ marginTop: 13 }} InputLabelProps={{ shrink: true }} placeholder="" />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('country', { initialValue: (this.props.country || ''), rules: [{ required: false }] })(
              <TextField id="country" label="country" color="primary" fullWidth style={{ marginTop: 13 }} InputLabelProps={{ shrink: true }} placeholder="" />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('phoneNumber', { initialValue: (this.props.phoneNumber || ''), rules: [{ required: false }] })(
              <TextField id="phoneNumber" label="phoneNumber" color="primary" fullWidth style={{ marginTop: 13 }} InputLabelProps={{ shrink: true }} placeholder="" />,
            )}
          </Grid>
          <Grid item xs={12}>
            {getFieldDecorator('previousName', { initialValue: (this.props.previousName || ''), rules: [{ required: false }] })(
              <TextField id="previousName" label="previousName" color="primary" fullWidth style={{ marginTop: 13 }} InputLabelProps={{ shrink: true }} placeholder="" />,
            )}
          </Grid>
          <Grid item xs={12} style={{ marginTop: '16px' }}>
            <SelectBrands label="Parent" brandId={this.state.parentId} setBrandId={this.handleParentChange} brandsFetchPolicy="cache-first" />
          </Grid>
        </Grid>
      </form>
    );
  }
}

const brandsForm = Form.create()(brandForm);

export default brandsForm;
